import { DelayActivityTypeCategoryDocument } from '../DelayActivityTypeCategory/queryBuilder';
import { create } from '../replication-v2/FamilyMember/create';
import { FamilyMember } from '../replication-v2/FamilyMember/FamilyMember';
import { ConfigBuilder, doNotAutoSync, pull, replicate } from '../replication-v2/replicate';
import { RxdbCollectionNameV2 } from '../replication-v2/RxdbCollectionNameV2';
import { SiteDocument } from '../Site/queryBuilder';
import { BorerActivityTypeDocument, borerActivityTypePullQueryBuilder } from './queryBuilder';

export function borerActivityTypeFamilyMember(
  configBuilder: ConfigBuilder,
  delayActivityTypeCategory: FamilyMember<DelayActivityTypeCategoryDocument>,
  sites: FamilyMember<SiteDocument>,
): FamilyMember<BorerActivityTypeDocument> {
  // BORER_ACTIVITY_TYPE uses activityTypeFeed which refers to the activity_type table.
  const syncConfig = configBuilder<BorerActivityTypeDocument>(
    RxdbCollectionNameV2.BORER_ACTIVITY_TYPE,
  );
  doNotAutoSync(syncConfig);

  pull(syncConfig, borerActivityTypePullQueryBuilder);

  const replicationState = replicate(syncConfig);
  // Legacy had the syncInterval at LiveInterval.MINUTES_15.
  return create(RxdbCollectionNameV2.BORER_ACTIVITY_TYPE, replicationState, [
    delayActivityTypeCategory,
    sites,
  ]);
}
